import { StoreApi, UseBoundStore, create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { TemplateSlice, createTemplateSlice } from './template.slice';

/**
 * Define an interface describing the overall restrictions store shape.
 */
export type IRestrictionsStore = TemplateSlice;

/**
 * Create the restrictions store with only template slice for now.
 */
export const useRestrictionsStore = create<IRestrictionsStore>()(
  devtools(
    immer((...args) => ({
      ...createTemplateSlice(...args),
    })),
    { name: 'Features | Restrictions' }
  )
);

export type RestrictionsStoreInjector = UseBoundStore<StoreApi<IRestrictionsStore>>;
